// src/audio-player.ts
import { Howl } from "howler";
var AudioPlayer = class {
  constructor(config = {}) {
    this.onLoad = null;
    this.onPlay = null;
    this.onPause = null;
    this.onSeek = null;
    this.onStop = null;
    this.onEnd = null;
    if (config.onLoad) this.onLoad = config.onLoad;
    if (config.onPlay) this.onPlay = config.onPlay;
    if (config.onPause) this.onPause = config.onPause;
    if (config.onSeek) this.onSeek = config.onSeek;
    if (config.onStop) this.onStop = config.onStop;
    if (config.onEnd) this.onEnd = config.onEnd;
  }
  getAudioInfo() {
    const info = {
      duration: 0,
      playing: false,
      state: "unloaded",
      seek: 0
    };
    if (this.howl) {
      info.duration = this.howl.duration();
      info.playing = this.howl.playing();
      info.state = this.howl.state();
      info.seek = this.howl.seek() instanceof Howl ? 0 : this.howl.seek();
    }
    return info;
  }
  load({
    source,
    format
  }) {
    if (source) {
      this.howl = new Howl({ src: source, format });
      if (this.onLoad) {
        this.howl.on("load", this.onLoad);
      }
      if (this.onPlay) {
        this.howl.on("play", this.onPlay);
      }
      if (this.onPause) {
        this.howl.on("pause", this.onPause);
      }
      if (this.onSeek) {
        this.howl.on("seek", this.onSeek);
      }
      if (this.onStop) {
        this.howl.on("stop", this.onStop);
      }
      if (this.onEnd) {
        this.howl.on("end", this.onEnd);
      }
    }
  }
  unload() {
    if (this.howl) {
      this.howl.unload();
      delete this.howl;
    }
  }
  play() {
    if (this.howl) {
      this.howl.play();
    }
  }
  pause() {
    if (this.howl) {
      this.howl.pause();
    }
  }
  stop() {
    if (this.howl) {
      this.howl.stop();
    }
  }
};

// src/audio-recorder.ts
var AudioRecorder = class {
  constructor(config = {}) {
    this.recorder = null;
    this.audioChunks = [];
    if (config.onNewRecording) this.onNewRecording = config.onNewRecording;
  }
  async getRecorder() {
    if (!this.recorder) {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const rec = new MediaRecorder(stream);
      rec.addEventListener("dataavailable", (event) => {
        this.audioChunks.push(event.data);
      });
      rec.addEventListener("stop", () => {
        const recordBlob = new Blob(this.audioChunks, { type: "audio/mpeg-3" });
        this.audioChunks = [];
        if (this.onNewRecording) {
          this.onNewRecording(recordBlob);
        }
      });
      this.recorder = rec;
    }
    return this.recorder;
  }
  async start() {
    this.audioChunks = [];
    const rec = await this.getRecorder();
    if (rec.state !== "recording") {
      rec.start();
    }
  }
  async stop() {
    const rec = await this.getRecorder();
    if (rec.state === "recording") {
      rec.stop();
    }
  }
};
export {
  AudioPlayer,
  AudioRecorder
};
